
// drag scroll
document.addEventListener("DOMContentLoaded", () => {
	const container = document.querySelector('.mm-wrapper-img-insta');
	let isDragging = false; 
	let startX, scrollLeft;
  
	container.addEventListener("mousedown", (e) => {
	  isDragging = true; // Activer le drag
	  container.classList.add("dragging");
	  startX = e.pageX - container.offsetLeft; 
	  scrollLeft = container.scrollLeft;
	});
  
	container.addEventListener("mouseleave", () => {
	  isDragging = false; // Désactiver le drag
	  container.classList.remove("dragging");
	});
  
	container.addEventListener("mouseup", () => {
	  isDragging = false; 
	  container.classList.remove("dragging");
	});
  
	container.addEventListener("mousemove", (e) => {
	  if (!isDragging) return; 
	  e.preventDefault(); 
	  const x = e.pageX - container.offsetLeft; 
	  const walk = (x - startX) * 1.5; 
	  container.scrollLeft = scrollLeft - walk; 
	});
  });